import { createSvgIcon } from '@mui/material/utils';

export const FacebookIcon = createSvgIcon(
    <path d='M14.2 2.875A4.624 4.624 0 009.573 7.5v2.574H7.102a.227.227 0 00-.227.227v3.398c0 .125.102.227.227.227h2.472v6.972c0 .125.102.227.227.227h3.398a.227.227 0 00.227-.227v-6.972h2.496c.105 0 .195-.07.219-.172l.851-3.399a.227.227 0 00-.219-.28h-3.347V7.5a.771.771 0 01.773-.773h2.602a.223.223 0 00.222-.227V3.102a.223.223 0 00-.222-.227zm0 0' />,
    'FacebookIcon'
);
